/* blnc-toc.js — auto-inject Table of Contents from H2 elements inside .blnc-page-body */
(function() {
  'use strict';

  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9\s-]/g, '')
      .trim()
      .replace(/\s+/g, '-')
      .substring(0, 60);
  }

  function buildToc() {
    var anchor = document.querySelector('#blnc-toc-anchor');
    var body = document.querySelector('.blnc-page-body');
    if (!anchor || !body) return;

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    if (headings.length < 2) return;

    headings.forEach(function(h2) {
      if (!h2.id) h2.id = slugify(h2.textContent);
    });

    var heading = anchor.getAttribute('data-toc-heading') || 'On this page';
    var items = headings.map(function(h) {
      return '<li><a href="#' + h.id + '" class="blnc-toc__link">' + h.textContent + '</a></li>';
    }).join('');

    anchor.innerHTML =
      '<nav class="blnc-toc" aria-label="' + heading + '">' +
      '<details class="blnc-toc__details" open>' +
      '<summary class="blnc-toc__summary">' +
      '<span class="blnc-toc__heading">' + heading + '</span>' +
      '<svg class="blnc-icon blnc-icon--chevron-down blnc-toc__chevron" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>' +
      '</summary>' +
      '<ul class="blnc-toc__list">' + items + '</ul>' +
      '</details>' +
      '</nav>';

    var links = anchor.querySelectorAll('.blnc-toc__link');
    var linkByHash = {};
    links.forEach(function(l) {
      linkByHash['#' + decodeURIComponent(l.hash.substring(1))] = l;
    });

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          links.forEach(function(l) { l.classList.remove('is-active'); });
          var link = linkByHash['#' + e.target.id];
          if (link) link.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });

    headings.forEach(function(h) { io.observe(h); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildToc);
  } else {
    buildToc();
  }
})();
